"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatTileGrid = StatTileGrid;
var jsx_runtime_1 = require("react/jsx-runtime");
var stat_tile_1 = require("./stat-tile");
var XL_COLUMN_CLASSES = {
    1: "xl:grid-cols-1",
    2: "xl:grid-cols-2",
    3: "xl:grid-cols-3",
    4: "xl:grid-cols-4",
    5: "xl:grid-cols-5",
    6: "xl:grid-cols-6",
};
function StatTileGrid(props) {
    var _a;
    var tiles = props.tiles;
    var xlColumns = (_a = XL_COLUMN_CLASSES[Math.min(tiles.length, 6)]) !== null && _a !== void 0 ? _a : XL_COLUMN_CLASSES[6];
    return ((0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 sm:grid-cols-2 ".concat(xlColumns, " gap-4"), children: tiles.map(function (tile) { return ((0, jsx_runtime_1.jsx)(stat_tile_1.StatTile, { tile: tile }, tile.label)); }) }));
}
